<template>
  <div ref="chartContainer">
    <apexchart
      v-if="ready"
      ref="chart"
      type="donut"
      :height="height"
      :series="series"
      :options="chartOptions"
      :width="width"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
  name: "PieChart",
  components: { apexchart: VueApexCharts },
  props: {
    series: { type: Array, required: true },
    height: { type: [String, Number], default: 350 },
    width: { type: [String, Number], default: null },
    options: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      ready: false,
      chartOptions: Object.freeze(this.mergeChartOptions()),
    };
  },
  methods: {
    mergeChartOptions() {
      const defaultOptions = {
        chart: {
          // Vue 3 has no `_uid` (it read undefined, so every chart got the same id); `$.uid`
          // is the per-instance counter it replaced.
          id: 'apex-pie-' + this.$.uid,
          toolbar: {
            show: true,
          },
          animations: { enabled: false },
          redrawOnParentResize: false,
          redrawOnWindowResize: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: '60%',
            },
          },
        },
        legend: {
          position: 'bottom',
        },
      };

      return Object.assign({}, defaultOptions, this.options);
    },
    waitForContainerWidth() {
      const el = this.$refs.chartContainer;
      if (!el) return;

      if (el.offsetWidth > 0) {
        this.ready = true;
        return;
      }

      if (typeof ResizeObserver !== 'undefined') {
        this._resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            if (entry.contentRect.width > 0) {
              this.ready = true;
              this._resizeObserver.disconnect();
              this._resizeObserver = null;
              break;
            }
          }
        });
        this._resizeObserver.observe(el);
      } else {
        this.ready = true;
      }
    },
  },
  mounted() {
    this.waitForContainerWidth();
  },
  beforeUnmount() {
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
  },
};
</script>
